import { gql } from '@apollo/client';

export const CREATE_TABLE = gql`
  mutation createTable {
    createTable
  }
`;
